<template>
  <div class="batchDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('payment_links.new_link')" :close-on-click-modal="false" width="739px">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('payment_links.batch_link_details') }}
      </div>
      <div class="section-tip">
        {{ $t('payment_links.tip_2') }}
      </div>
      <div class="step">
        <div class="step-item">
          <div class="step-item-left">
            <div class="section-step-title">{{ $t('send_pagements.excel_worksheet_template_excel') }}</div>
            <div class="section-tip"> {{ $t('tips.latest_template') }}  </div>
          </div>
          <div><el-button class="btn-download" type="primary" size="small" icon="el-icon-download" @click="onClickDownloadBtn">{{ $t('customerService.download_template') }}</el-button>
            <div style="margin-top: 10px;">{{ $t('tips.please_upload_latest_template') }}</div>
          </div>
        </div>
        <div class="line-bottom-1px" style="margin-bottom: 32px" />
        <div class="step-item">
          <div class="step-item-left" style="margin-top: 32px">
            <div class="section-step-title">{{ $t('tips.upload_filled_excel_worksheet_template') }}</div>
            <div class="section-tip">   {{ $t('payment_links.tip_3') }}</div>
          </div>
          <div><PaymentUploadExcelFile :reference-batch-no="reference_batch_no" @templateFileSuccess="templateFileSuccess" v-on="$listeners" /></div>
        </div>
        <!-- <div class="step-item">
          <div class="step-item-title">Batch reference</div>
          <div> <el-input v-model="batchDisbursement.remark" type="text" autocomplete="off" /></div>
        </div> -->
      </div>

      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import { fetchReferenceBatchNo } from '@/api/online-transaction/online-transaction.js'
import { download } from '@/utils/common'
export default {
  name: 'Batch_Payment_Modal',
  components: {
    PaymentUploadExcelFile: () => import('../file/PaymentUploadExcelFile.vue')
  },
  props: {
    merchantInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    balance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      reference_batch_no: null
    }
  },
  methods: {
    // 改变弹框状态
    changModalStatus(value) {
      if (value) {
        this.getReferenceBatchNo(value)
        return
      }
      this.dialogVisible = value
    },
    getReferenceBatchNo(value) {
      fetchReferenceBatchNo().then(res => {
        if (res.code === 10000) {
          this.reference_batch_no = res.data
          this.dialogVisible = value
        }
      })
    },
    templateFileSuccess() {
      this.changModalStatus(false)
      this.$emit('getAllReferenceInfo')
    },
    onClickDownloadBtn() {
      download('https://calf.oss-cn-shanghai.aliyuncs.com/pay-excel/Batch_PaymentLinks_Template.xlsx', '_blank')
    }
  }
}
</script>

<style scoped>
.step{

}
.step-item{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.step-item-left{
  width: 300px;
}
.section-step-title{
  margin-bottom: 12px;
  font-weight: 500;  font-family: 'Poppins-Medium';
  font-size: 14px;
  line-height: 1.2;
  background: linear-gradient(180deg, #488CE8 0%, #0058CF 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;;
}
.btn-download{
  font-weight: 400;
  font-size: 15px;
}

.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  margin-bottom: 4px;
  width: 120px;
  height: 40px;
  background: #0F68E0;
  border-radius: 100px;
}
</style>
